import React from 'react';
import FormOperacion from '../../components/forms/formOperacion';

const NewOperacion = () => {
    return (
        <FormOperacion/>
    );
}
 
export default NewOperacion;